<script>
import MessageContentQuickReply from '@/components/message/MessageContentQuickReply.vue'

export default {
    name: 'MessageContentRating',
    extends: MessageContentQuickReply
}
</script>
